function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { findByConditions, semiautomatic_mine, proposalCallWriteBack_fun, proposalCallBack_fun } from '@/api/policymanagement';
import { getBaseDateList, getProductList, getCompanyList } from '@/api/baseDate'; //查询产品进出口标识

import { product_queryProduct } from '@/api/baseDataManage';
export default {
  name: "policyentry",
  data: function data() {
    var _ref;

    return _ref = {
      //1.申请电子保单同步方法是否返回结果 0没有返回过 1 返回过
      doPolicy1: 0,
      //2.申请电子保单轮询方法是否返回结果 0没有返回过 1 返回过
      doPolicy2: 0,
      //3.计时---毫秒数
      doPolicyCount: 0,
      //4.定时器
      loading: false,
      loing_box: false,
      queryType: '',
      protocolNo: '',
      insurancecompanyCode: '',
      insurancecompanyName: '',
      termsOfTrade: '',
      riskCode: '',
      riskName: '',
      conriskName: '',
      value: '',
      currentPage3: '',
      tableData: [],
      options1: [{
        value: "1",
        label: "111"
      }],
      options2: [{
        value: "2",
        label: "2222"
      }],
      options3: [{
        value: "3",
        label: "333"
      }],
      dialogFormVisible: false,
      dialogFormVisibleone: false,
      mydeclaration: false,
      box_10: false,
      applicationNo: '',
      okthrough: false,
      dcollection: false,
      footerbtn_1: false,
      footerbtn_2: false,
      declarationlist: {
        tradeco: '',
        grossWt: '',
        customNo: ''
      },
      pageNo: 1,
      pageSize: 10,
      total: 0,
      inForm: {},
      rules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }, {
          min: 3,
          max: 5,
          message: '长度在 3 到 5 个字符',
          trigger: 'blur'
        }]
      },
      row: '',
      rowName: '',
      tradeTerms_option: [],
      options_insuranceCompanyName: []
    }, _defineProperty(_ref, "options2", []), _defineProperty(_ref, "data", ''), _defineProperty(_ref, "declarationlist_rules", {
      customNo: [{
        required: true,
        message: '请输入报关单号',
        trigger: 'blur'
      }],
      grossWt: [{
        required: true,
        message: '请输入毛重 （KG）',
        trigger: 'blur'
      }],
      tradeco: [{
        required: true,
        message: '请输入境内收发货人编码',
        trigger: 'blur'
      }]
    }), _ref;
  },
  watch: {
    '$route': 'getPath' // 当路由发生变化时执行此函数

  },
  created: function created() {
    console.log("页面protocol-entry.vue");
    console.log(this.$route.params);
    this.get_data();
    var list = this.$store.state.user.userinfo.insuranceCompanyList || [];
    var companyCode = '';

    if (this.$store.state.user.userinfo.insuranceCompanyList.length !== 0) {
      companyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || '';
    } // 不同角色用户登录进去保险公司数据源不同
    // 货运险注册用户：register insuranceCompanyList
    // 子账号被保险人用户：subAssured sainsuranceCompanyList
    // 货运险注册用户+子账号被保险人用户 两者合并


    var userRoleType = this.$store.state.user.userinfo.userRoleType;

    if (userRoleType !== null && userRoleType.includes('subAssured')) {
      var saList = this.$store.state.user.userinfo.sainsuranceCompanyList || [];
      var saCompanyCode = this.$store.state.user.userinfo.sainsuranceCompanyList[0].insuranceCompanyCode || '';

      if (userRoleType === 'subAssured') {
        list = saList;
        companyCode = saCompanyCode;
      } else {
        list = list.concat(saList).filter(function (item, index, array) {
          return array.indexOf(item) === index;
        });
      }
    }

    this.get_select(list, companyCode);
  },
  methods: {
    getPath: function getPath() {
      this.search_s();
    },
    // 上传校验
    beforeUploadimg: function beforeUploadimg(file) {
      console.log(file, 'file');
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
      var extension = testmsg === 'jpg';
      var extension2 = testmsg === 'png';
      var extension3 = testmsg === 'JPG';
      var extension4 = testmsg === 'PNG';
      var extension5 = testmsg === 'jpeg';
      var extension6 = testmsg === 'pdf';
      var isLt2M = file.size / 1024 / 2048 < 1;

      if (!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6) {
        this.$message({
          message: '上传图片文件类型不正确，请确认后重新上传',
          type: 'warning'
        });
      }

      ;

      if (!isLt2M) {
        this.$message({
          message: '上传图片文件大小不能超过 2MB!',
          type: 'warning'
        });
      }

      return extension && isLt2M || extension2 && isLt2M || extension3 && isLt2M || extension4 && isLt2M || extension5 && isLt2M || extension6 && isLt2M; // return extension|| extension2 || extension3 || extension4 || extension5
    },
    //上传执照
    upload: function upload(file) {
      console.log(file);
      var typeList = ['image/gif', 'image/jpg', 'image/jpeg', 'image/bmp', 'image/png', 'pdf'];

      if (typeList.indexOf(file.file.type)) {
        var dataFile = new FormData();
        dataFile.append('file', file.file);
        LicenseInfo(dataFile).then(function (res) {
          console.log(res); // if(res.biz_license_credit_code != null){
          // }else {
          //   this.$message({
          //     message: '十八位信用代码未识别',
          //     type: 'warning'
          //   })
          // }
        });
      } else {
        this.$message({
          message: '请选择图片',
          type: 'warning'
        });
      }
    },
    //上传成功
    upSucc: function upSucc(res, file, fileList) {
      console.log(res, file, fileList);
    },
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      this.pageSize = val;
      this.get_data();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
      this.pageNo = val;
      this.get_data();
    },
    View_but: function View_but(index, scope) {
      var _this = this;

      // console.log(index)
      // console.log(scope)
      this.row = scope.row.riskCode.split('|')[index];
      this.rowName = scope.row.riskName.split('|')[index];
      this.conriskName = this.rowName;
      this.data = scope; //YCKK-1393 贸易平台外航投保时增加提示-俄罗斯产原油(HS CODE 270900)及石油产品(HS CODE 2710)为禁止承保货物 2023-02-27

      if (this.row == "CMAR" || this.row == "CEXP") {
        var message = "<p style=\"word-wrap:break-word;\">\u4FC4\u7F57\u65AF\u4EA7\u539F\u6CB9(HS CODE 270900)\u53CA\u77F3\u6CB9\u4EA7\u54C1(HS CODE 2710)\u4E3A\u7981\u6B62\u627F\u4FDD\u8D27\u7269\u3002(This policy does not cover Russian crude oil and Russian petrochemical products falling under HS code 2709 00 and HS code 2710.) \u8BF7\u4E86\u89E3\u3002\n                            <br><br>\u507F\u4ED8\u80FD\u529B\u4FE1\u606F\u516C\u5F00\u62AB\u9732\uFF1A\n                            <br>\u8BF7\u901A\u8FC7\u5982\u4E0B\u5B98\u7F51\u94FE\u63A5\uFF0C\u5728\u201C\u4E13\u9879\u4FE1\u606F\u201D\u62AB\u9732\u680F\u4E2D\u83B7\u53D6\u672C\u516C\u53F8\u6700\u65B0\u507F\u4ED8\u80FD\u529B\u76F8\u5173\u4FE1\u606F\u3002\n                            <br><a href=\"https://www.ms-ins.com.cn/BaseInfo.html#base4\" target=\"_blank\" style=\"text-decoration: underline;\">https://www.ms-ins.com.cn/BaseInfo.html#base4</a>\n                            </p>";
        this.$confirm(message, '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '已了解',
          closeOnClickModal: false,
          cancelButtonClass: 'custom-button',
          customClass: 'custom-button-frame',
          callback: function callback(action) {
            console.log('已了解'); //YCKK-1013 人太保对接UAT环境：ll001/msig1234配置的产品是进口，但是我投保的时候没有提示我报关单投保还是非报关单投保
            //查询产品的进出口标志，分为进口、出口、内陆，没有标识

            var timer = setTimeout(function () {
              //需要定时执行的代码
              product_queryProduct({
                riskCode: _this.row,
                insuranceCompanyCode: _this.data.row.insurancecompanyCode
              }).then(function (res) {
                //this.rowName != "出口货物运输保险" && this.rowName != "进口货物运输保险"
                if (res.ieFlag != '1' && res.ieFlag != "2") {
                  console.log(_this.data);
                  var params = {
                    type: "add",
                    insurancecompanyCode: _this.data.row.insurancecompanyCode,
                    protocolNo: _this.data.row.protocolNo,
                    riskCode: _this.row,
                    riskName: _this.rowName,
                    proposalNo: '11'
                  };

                  _this.$router.push({
                    name: 'insuranceentry1',
                    params: params //path: `/policymanagement/insuranceentry/${params.type}/${params.insurancecompanyCode}/${params.protocolNo}/${params.riskCode}/${params.riskName}/${params.proposalNo}`

                  });
                } else {
                  _this.dialogFormVisible = true;
                  _this.dialogFormVisibleone = true;
                  _this.mydeclaration = false;
                }
              });
            }, 500);
          }
        });
      } else if (this.row == "CINL") {
        var _message = "<p style=\"word-wrap:break-word;\">\n                            \u507F\u4ED8\u80FD\u529B\u4FE1\u606F\u516C\u5F00\u62AB\u9732\uFF1A\n                            <br>\u8BF7\u901A\u8FC7\u5982\u4E0B\u5B98\u7F51\u94FE\u63A5\uFF0C\u5728\u201C\u4E13\u9879\u4FE1\u606F\u201D\u62AB\u9732\u680F\u4E2D\u83B7\u53D6\u672C\u516C\u53F8\u6700\u65B0\u507F\u4ED8\u80FD\u529B\u76F8\u5173\u4FE1\u606F\u3002\n\n                            <br><a href=\"https://www.ms-ins.com.cn/BaseInfo.html#base4\" target=\"_blank\" style=\"text-decoration: underline;\">https://www.ms-ins.com.cn/BaseInfo.html#base4</a>\n                            </p>";
        this.$confirm(_message, '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '已了解',
          closeOnClickModal: false,
          cancelButtonClass: 'custom-button',
          customClass: 'custom-button-frame',
          callback: function callback(action) {
            console.log('已了解');
            var timer = setTimeout(function () {
              product_queryProduct({
                riskCode: _this.row,
                insuranceCompanyCode: _this.data.row.insurancecompanyCode
              }).then(function (res) {
                //this.rowName != "出口货物运输保险" && this.rowName != "进口货物运输保险"
                if (res.ieFlag != '1' && res.ieFlag != "2") {
                  console.log(_this.data);
                  var params = {
                    type: "add",
                    insurancecompanyCode: _this.data.row.insurancecompanyCode,
                    protocolNo: _this.data.row.protocolNo,
                    riskCode: _this.row,
                    riskName: _this.rowName,
                    proposalNo: '11',
                    queryType: _this.data.row.queryType
                  };

                  _this.$router.push({
                    name: 'insuranceentry1',
                    params: params //path: `/policymanagement/insuranceentry/${params.type}/${params.insurancecompanyCode}/${params.protocolNo}/${params.riskCode}/${params.riskName}/${params.proposalNo}`

                  });
                } else {
                  _this.dialogFormVisible = true;
                  _this.dialogFormVisibleone = true;
                  _this.mydeclaration = false;
                }
              });
            }, 500);
          }
        });
      } else {
        product_queryProduct({
          riskCode: this.row,
          insuranceCompanyCode: this.data.row.insurancecompanyCode
        }).then(function (res) {
          //this.rowName != "出口货物运输保险" && this.rowName != "进口货物运输保险"
          if (res.ieFlag != '1' && res.ieFlag != "2") {
            console.log(_this.data);
            var params = {
              type: "add",
              insurancecompanyCode: _this.data.row.insurancecompanyCode,
              protocolNo: _this.data.row.protocolNo,
              riskCode: _this.row,
              riskName: _this.rowName,
              proposalNo: '11',
              queryType: _this.data.row.queryType
            };

            _this.$router.push({
              name: 'insuranceentry1',
              params: params //path: `/policymanagement/insuranceentry/${params.type}/${params.insurancecompanyCode}/${params.protocolNo}/${params.riskCode}/${params.riskName}/${params.proposalNo}`

            });
          } else {
            _this.dialogFormVisible = true;
            _this.dialogFormVisibleone = true;
            _this.mydeclaration = false;
          }
        });
      }
    },
    handleClose: function handleClose() {
      this.form = {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      };
    },
    handleSave: function handleSave() {},
    get_data: function get_data() {
      var _this2 = this;

      this.loading = true;
      var data = {
        insurancecompanyCode: this.insurancecompanyCode,
        insurancecompanyName: this.insurancecompanyName,
        termsOfTrade: this.termsOfTrade,
        riskCode: this.riskCode,
        riskName: this.riskName,
        protocolNo: this.protocolNo,
        protocolStatus: "05",
        auditStatus: "2",
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        type: '1'
      };
      findByConditions(data).then(function (res) {
        _this2.tableData = res.content;
        _this2.total = res.totalCount;
        _this2.loading = false; //

        var formatter = new Intl.DateTimeFormat('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });

        if (_this2.tableData) {
          for (var i = 0; i < _this2.tableData.length; i++) {
            // 协议生效日期省去时分秒
            if (_this2.tableData[i].agreementStartDate != undefined && _this2.tableData[i].agreementStartDate != null) {
              _this2.tableData[i].agreementStartDate = formatter.format(new Date(_this2.tableData[i].agreementStartDate)).replace(/\//g, '-');
            }

            if (_this2.tableData[i].agreementEndDate != undefined && _this2.tableData[i].agreementEndDate != null) {
              _this2.tableData[i].agreementEndDate = formatter.format(new Date(_this2.tableData[i].agreementEndDate)).replace(/\//g, '-');
            }
          }
        }
      });
    },
    //查询
    search_s: function search_s() {
      this.pageNo = 1; // 去除空格

      this.protocolNo = this.protocolNo.trim();
      this.get_data();
    },
    clear_s: function clear_s() {
      this.protocolNo = '', this.insurancecompanyCode = '';
      this.insurancecompanyName = '';
      this.termsOfTrade = '';
      this.riskCode = '';
      this.riskName = ''; //清空产品下拉

      this.options2 = [];
    },
    list_select: function list_select(val, list) {
      var obj = {};
      obj = list.find(function (item) {
        //这里的userList就是上面遍历的数据源
        return item.value === val; //筛选出匹配数据
      });
      return obj.label;
    },
    insurancecompanyCode_ch: function insurancecompanyCode_ch(val) {
      this.insurancecompanyName = this.list_select(val, this.options_insuranceCompanyName);
      this.riskCode = "";
      this.riskqueryAll_fun(val);
    },
    riskCode_ch: function riskCode_ch(val) {
      this.riskName = this.list_select(val, this.options2);
    },
    //我已报关
    already_customs: function already_customs() {
      this.dialogFormVisibleone = false;
      this.mydeclaration = true;
    },
    myconfirm: function myconfirm(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.loing_box = true;
          var data = {
            customNo: _this3.declarationlist.customNo.trim(),
            grossWt: parseFloat(_this3.declarationlist.grossWt),
            protocolNo: _this3.data.row.protocolNo,
            riskCode: _this3.row,
            tradeco: _this3.declarationlist.tradeco.trim()
          };
          semiautomatic_mine(data).then(function (res) {
            if (res.rtnCode == "0000") {
              // 判断自核是否通过 以及提交状态
              if (res.isUndwrt == "1" && res.proposalStatus == "3") {
                _this3.applicationNo = res.proposalNo;
                _this3.box_10 = true;
                _this3.okthrough = true;
                _this3.dcollection = false;
                _this3.footerbtn_1 = true;
                _this3.footerbtn_2 = false;
              } else if (res.proposalStatus == "1") {
                _this3.applicationNo = res.proposalNo;
                _this3.box_10 = true;
                _this3.okthrough = false;
                _this3.dcollection = true;
                _this3.footerbtn_1 = false;
                _this3.footerbtn_2 = true;
              } else if (res.proposalStatus == "1" || res.isUndwrt == "0") {
                _this3.$alert('<p>您的投保申请 ' + res.proposalNo + '未能自动核保通过</p>', '', {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: '确定',
                  callback: function callback(action) {}
                });
              }
            } else {
              var alertstr = '<p>' + res.rtnMsg + '</p>';

              if (res.resultErrList != null) {
                for (var i = 0; i < res.resultErrList.length; i++) {
                  alertstr = alertstr + '<p>' + res.resultErrList[i].message + '</p>';
                }
              }

              _this3.$alert(alertstr, '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: function callback(action) {
                  _this3.dialogFormVisible = true;
                  _this3.mydeclaration = true;
                }
              });
            }

            _this3.loing_box = false;
          }, function (res) {
            _this3.loing_box = false;
          });
          _this3.declarationlist = {
            tradeco: '',
            grossWt: '',
            customNo: ''
          };
          _this3.dialogFormVisible = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //申请电子保单
    ask_policy: function ask_policy() {
      this.doPolicy1 = 0;
      this.doPolicy2 = 0;
      this.doPolicyCount = Date.now();
      setTimeout(this.doPolicyTimer(), 20000);
      this.toapplyfor(1);
    },
    //申请电子凭证
    ask_policy_assess: function ask_policy_assess() {
      this.toapplyfor(2);
    },
    handleClose_box: function handleClose_box(done) {
      this.box_10 = false;
    },
    // 这是一个定时器
    doPolicyTimer: function doPolicyTimer() {
      var _this4 = this;

      var doPolicyTimerId = setInterval(function () {
        var timeCount = Date.now();
        console.log("轮询" + timeCount);

        if (timeCount - _this4.doPolicyCount > 120000) {
          console.log("轮询结束--------2分钟超时关闭");
          clearInterval(doPolicyTimerId);

          _this4.$alert('<p>数据正在推送核心，请稍等片刻再查询投保单状态，投保单状态变更前请不要进行重复操作</p>', '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: function callback(action) {
              _this4.$store.dispatch('delVisitedViews', _this4.$route);

              _this4.$router.push({
                path: "/policymanagement/policysearch"
              });
            }
          });

          _this4.loing_box = false;
        } else {
          console.log("判断是否轮询");

          if (_this4.doPolicy1 == 0 && _this4.doPolicy2 == 0) {
            console.log("每隔5秒-------------------轮询接口调用开始");
            var data = {
              reqProposalCallDtoList: [{
                proposalNo: _this4.applicationNo,
                type: 1
              }]
            };
            proposalCallBack_fun(data).then(function (res) {
              if (res.rtnCode == '0000') {
                var businessNo = res.businessNo;

                if (businessNo == null) {
                  businessNo = '';
                }

                if (res.policyNo == null) {
                  _this4.$alert('<p>询价单号：' + businessNo + '</p><p>申请电子保单，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: function callback(action) {
                      _this4.$store.dispatch('delVisitedViews', _this4.$route);

                      _this4.$router.push({
                        path: "/policymanagement/policysearch"
                      });
                    }
                  });
                } else {
                  _this4.$alert('<p>询价单号：' + businessNo + '</p><p>保单号：' + res.policyNo + '</p><p>申请电子保单，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: function callback(action) {
                      _this4.$store.dispatch('delVisitedViews', _this4.$route);

                      _this4.$router.push({
                        path: "/policymanagement/policysearch"
                      });
                    }
                  });
                }

                _this4.doPolicy2 = 1;
                _this4.loing_box = false;
              } else if (res.rtnCode == '9999') {
                console.log("没有结果继续轮询");
              }
            });
          } else {
            console.log("判断不轮询-----------轮询结束--------状态变化关闭");
            clearInterval(doPolicyTimerId);
          }
        }
      }, 5000);
    },
    //-------------------------    1-申请电子保单，2-申请CI凭证
    toapplyfor: function toapplyfor(type) {
      var _this5 = this;

      this.box_10 = false;
      this.loing_box = true;
      var data = {
        reqProposalCallDtoList: [{
          proposalNo: this.applicationNo,
          protocolNo: this.data.row.protocolNo,
          type: type
        }]
      };

      if (type == "1") {
        proposalCallWriteBack_fun(data).then(function (res) {
          console.log("申请电子保单结果开始" + _this5.doPolicy2);

          if (_this5.doPolicy2 == 0) {
            if (res.rtnCode == "0000") {
              if (res.policyNo == null) {
                _this5.$alert('<p>询价单号：' + res.businessNo + '</p><p>申请电子保单，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: '确定',
                  callback: function callback(action) {
                    _this5.$store.dispatch('delVisitedViews', _this5.$route);

                    _this5.$router.push({
                      path: "/policymanagement/policysearch"
                    });
                  }
                });
              } else {
                _this5.$alert('<p>询价单号：' + res.businessNo + '</p><p>保单号：' + res.policyNo + '</p><p>申请电子保单，提交成功，请在投保单/保单查询菜单执行后续操作</p>', '', {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: '确定',
                  callback: function callback(action) {
                    _this5.$store.dispatch('delVisitedViews', _this5.$route);

                    _this5.$router.push({
                      path: "/policymanagement/policysearch"
                    });
                  }
                });
              }
            } else if (res.rtnCode == "9999") {
              _this5.$alert('<p>' + res.data + '</p>', '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: function callback(action) {
                  _this5.$store.dispatch('delVisitedViews', _this5.$route);

                  _this5.$router.push({
                    path: "/policymanagement/policysearch"
                  });
                }
              });
            } else {
              /*this.$alert('<p>申请电子保单，提交失败</p>', '', {
              	dangerouslyUseHTMLString: true,
              	confirmButtonText: '确定',
              	callback: action => {
              		this.$store.dispatch('delVisitedViews', this.$route);
              		this.$router.push({
              			path: `/policymanagement/policysearch`
              		});
              	}
              });*/
            }

            console.log("------------------------");
            _this5.loing_box = false;
            _this5.doPolicy1 = 1;
          }
        }, function (res) {
          _this5.loing_box = false;
        });
      } else if (type == "2") {
        proposalCallWriteBack_fun(data).then(function (res) {
          if (res.rtnCode == "0000") {
            _this5.$alert('<p>申请CI凭证成功</p>', '', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              callback: function callback(action) {
                _this5.$store.dispatch('delVisitedViews', _this5.$route);

                _this5.$router.push({
                  path: "/policymanagement/policysearch"
                });
              }
            });
          } else if (res.rtnCode == "9999") {
            _this5.$alert('<p>申请CI凭证失败</p>', '', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              callback: function callback(action) {
                _this5.$store.dispatch('delVisitedViews', _this5.$route);

                _this5.$router.push({
                  path: "/policymanagement/policysearch"
                });
              }
            });
          }

          _this5.loing_box = false;
        });
      }
    },
    // 立即补录
    dcollection_go: function dcollection_go() {
      this.box_10 = false;
      var params = {
        type: "collection",
        insurancecompanyCode: this.data.row.insurancecompanyCode,
        protocolNo: this.data.row.protocolNo,
        riskCode: this.row,
        riskName: this.rowName,
        proposalNo: this.applicationNo
      }; // console.log(this.applicationNo)

      this.$router.push({
        name: 'insuranceentry2',
        params: params //path: `/policymanagement/insuranceentry/${params.type}/${params.insurancecompanyCode}/${params.protocolNo}/${params.riskCode}/${params.riskName}/${params.proposalNo}`

      });
    },
    //尚未报关
    no_customs: function no_customs() {
      // console.log(this.data)
      // console.log(this.row)
      var params = {
        type: "add",
        insurancecompanyCode: this.data.row.insurancecompanyCode,
        protocolNo: this.data.row.protocolNo,
        riskCode: this.row,
        riskName: this.rowName,
        proposalNo: '11',
        queryType: this.data.row.queryType
      };
      this.$router.push({
        name: 'insuranceentry1',
        params: params //path: `/policymanagement/insuranceentry/${params.type}/${params.insurancecompanyCode}/${params.protocolNo}/${params.riskCode}/${params.riskName}/${params.proposalNo}`

      });
      this.dialogFormVisible = false;
    },
    get_select: function get_select(list, code) {
      this.codeTypeList_fun();
      this.findInsuranceCompany_fun(list);
    },
    //贸易条件
    codeTypeList_fun: function codeTypeList_fun() {
      var _this6 = this;

      var data = {
        "codeLever": "1",
        "codeType": ["tradeTerms"]
      };
      getBaseDateList(data).then(function (res) {
        _this6.tradeTerms_option = [];

        for (var i = 0; i < res.length; i++) {
          if (res[i].codeType == "tradeTerms") {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this6.tradeTerms_option.push(obj);
            } //							console.log(this.tradeTerms_option)

          }
        }
      });
    },
    //保险公司
    findInsuranceCompany_fun: function findInsuranceCompany_fun(list) {
      this.options_insuranceCompanyName = [];

      for (var i = 0; i < list.length; i++) {
        var obj = {};
        obj.value = list[i].insuranceCompanyCode;
        obj.label = list[i].insuranceCompanyName;

        if (!obj.value || !obj.label) {
          this.options_insuranceCompanyName = [];
        } else {
          this.options_insuranceCompanyName.push(obj);
        }
      } //				var data = {
      //					insuranceCompanyCode: code
      //				}
      //
      //				getCompanyList(data).then(res => {
      //
      //					this.options_insuranceCompanyName = []
      //					for(var i = 0; i < res.length; i++) {
      //						var obj = {}
      //						console.log(res)
      //						obj.value = res[i].insuranceCompanyCode
      //						obj.label = res[i].insuranceCompanyName
      //						this.options_insuranceCompanyName.push(obj)
      //					}
      //
      //				})

    },
    //产品名称
    riskqueryAll_fun: function riskqueryAll_fun(code) {
      var _this7 = this;

      this.options2 = [];
      var data = {
        insuranceCompanyCode: code
      };
      getProductList(data).then(function (res) {
        _this7.options2 = [];

        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].riskCode;
          obj.label = res[i].riskName;

          _this7.options2.push(obj);
        }

        console.log(_this7.options2);
      });
    },
    //协议查看
    look_s: function look_s(row) {
      var type = "view";
      var queryType = row.queryType;
      this.$router.push({
        path: "/policymanagement/viewprotocol/".concat(row.protocolNo, "/").concat(type),
        query: {
          queryType: queryType
        }
      }); //				this.$router.push({
      //					path: 'viewprotocol',
      //					params: {
      //						protocolNo: row.protocolNo,
      //						operationType: "view"
      //					}
      //				})
    }
  }
};